import { Injectable } from '@angular/core';
import { RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';
import { Favourite, FavouriteCollectionMember } from 'ri-api-client';

@Injectable()
export class FavoritesService {

  public favorites: Favourite.Favourite[] = [];

  constructor(
    private apiService: ApiService,
  ) {
    this.apiService.init();
  }

  get(): Observable<FavouriteCollectionMember.FavouriteCollectionMember> {
    return this.apiService.client.favourites.GET()
      .map((res) => {
        return this.favorites = this.apiService.handleResponse(res);
      });
  }

  getById(id: number): Observable<Favourite.Favourite> {
    return this.apiService.client.favourites.id(id.toString()).GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  post(favorite: Favourite.Favourite): Observable<any[]> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.apiService.client.favourites.POST(favorite, options)
      .map((res) => {
        const response = this.apiService.handleResponse(res);
        this.favorites.push(response);
        return response;
      });
  }

  update(key: Number, favorite: any): Observable<any[]> {
    const favoriteToUpdated = this.favorites.find(u => u.id === key);
    const json = favorite;
    const keysOfUpdateFavoriteto = Object.keys(favoriteToUpdated);
    keysOfUpdateFavoriteto.forEach(k => (favoriteToUpdated[k] = json[k] || favoriteToUpdated[k]));
    return this.apiService.client.favourites.id(favoriteToUpdated.id.toString()).PATCH(favoriteToUpdated)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  delete(key: Number): Observable<any[]> {
    // this.favorites.splice(this.favorites.findIndex(x => x.id === key), 1);
    return this.apiService.client.favourites.id(key.toString()).DELETE()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api/favorites.service.ts